import React from 'react';

const Table = ({ headers = [], data = [], renderRow, loading = false, emptyMessage = 'No data available' }) => {
  return (
    <div className="w-full overflow-hidden rounded-xl border border-slate-200/80 dark:border-slate-700/80 bg-white dark:bg-[#1e293b] shadow-[0_4px_20px_0_rgba(0,0,0,0.02)]">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-200/80 dark:divide-slate-700/80 text-left text-sm">
          <thead className="bg-slate-50/80 dark:bg-slate-800/60">
            <tr>
              {headers.map((header, index) => (
                <th
                  key={index}
                  scope="col"
                  className="px-6 py-3.5 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 dark:divide-slate-700/60 bg-white dark:bg-[#1e293b]">
            {loading ? (
              <tr>
                <td colSpan={headers.length} className="px-6 py-12 text-center text-slate-400">
                  <div className="inline-flex items-center gap-2">
                    <div className="w-4 h-4 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
                    <span>Loading data...</span>
                  </div>
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={headers.length} className="px-6 py-12 text-center text-slate-400">
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              data.map((item, idx) => renderRow(item, idx))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
